module.exports = __webpack_public_path__ + "web/img/type-7.c9ed5f58.png";